import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './index.scss';

const cx = classNames.bind(styles);

const PictureAndPicture = () => <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="currentColor" height="1em" viewBox="0 -960 960 960" width="1em"><path d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Zm306-45h335v-257H446v257Zm60-60v-137h215v137H506Z"/></svg>

const PictureInPictureButton = ({ onClick }) => (
  <>
    <button
      className={`op-navigators op-button  ${cx('PictureInPictureButton')}`}
      type="button"
      title="Picture-in-Picture"
      onClick={onClick}
    >
      <i role="img" className="op-con">
        <PictureAndPicture />
      </i>
    </button>
  </>
);

PictureInPictureButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PictureInPictureButton;
